"use client";

import dynamic from "next/dynamic";
import LazyOnView from "@/components/LazyOnView";

// نظرات در HTML سرور لیست نمی‌شوند (سمت کلاینت دریافت می‌شوند)، پس فقط نزدیک viewport لود می‌شوند.
// بدون loading fallback تا DOM دوبار ساخته نشود.
const Comments = dynamic(() => import("@/components/Comments"), { ssr: false });

const BlogComments = ({ data }) => (
    <LazyOnView min_height="240px">
        <Comments data={data} model_name="BlogModel" />
    </LazyOnView>
);

export default BlogComments;
